/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { I18nService } from '@dm/core';
import { type Observable } from 'rxjs';

import { InfigoService } from '../../../infigo.service';
import { SourceEnumService } from '../../../source-enum.service';
import { RefreshComponent } from '../../RefreshComponent';

@Component({
    selector: 'app-lun-snap-shot-base-info',
    templateUrl: './lun-snap-shot-base-info.component.html',
})
export class LunSnapShotBaseInfoComponent extends RefreshComponent {
    @Input() item;
    detail = {};
    loading = true;
    baseInfo;
    HEALTHSTATUS_COLOR = this.enumService.get('LUN', 'HEALTHSTATUS_COLOR');

    constructor(
        public infigoService: InfigoService,
        public i18n: I18nService,
        public enumService: SourceEnumService,
        public changeDetectorRef: ChangeDetectorRef,
    ) {
        super();
        const I18N = i18n.get;
        const enumGet = enumService.get.bind(enumService, 'LUNSNAPSHOT');
        this.baseInfo = [
            {
                title: I18N('common.healthStatus_column'),
                key: 'HEALTHSTATUS',
                enumMap: enumGet('HEALTHSTATUS'),
                templateName: 'FlagText',
                templateParams: {
                    colorMap: this.HEALTHSTATUS_COLOR,
                },
            },
            {
                title: I18N('common.runningStatus_column'),
                key: 'RUNNINGSTATUS',
                enumMap: enumGet('RUNNINGSTATUS'),
            },
            {
                title: I18N('protection.snapshotCG_term_activatePointTime_column'),
                key: 'TIMESTAMP',
                templateName: 'Time',
            },
            {
                title: I18N('common.sourceLun_label'),
                key: 'SOURCELUNNAME',
            },
            {
                title: I18N('common.parentObject'),
                key: 'PARENTNAME',
            },
            {
                title: I18N('protection.snapshotCG_term_ownSnapshotConsistentGroup_label'),
                key: 'snapCgName',
            },
            {
                title: I18N('storage.lun_view_summary_localWWN_label'),
                key: 'WWN',
                isLongString: true,
            },
        ];
    }

    requestInfo(): Observable<any> {
        return this.infigoService.getSpecialSnapShot(this.item.actionParams);
    }

    handleRequest(value: any): void {
        this.detail = value.data;
        this.loading = false;
        this.clearTimer();
        this.updateLoading = false;
        this.changeDetectorRef.detectChanges();
    }
}
